export const environment = {
    production: true,
    version: '20250521.3' // Version number placeholder, will be replaced with actual version in pipelines
};
